"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpreadingEvent = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const EffluentTracker_1 = require("../Effluent/EffluentTracker");
const LateralEffluentSpreader_1 = require("../Effluent/LateralEffluentSpreader");
const PivotEffluentSpreader_1 = require("./PivotEffluentSpreader");
const SpreadingGun_1 = require("./SpreadingGun");
const TravellingEffluentSpreader_1 = require("./TravellingEffluentSpreader");
const DefinitionAndHelpers_1 = require("../../DefinitionAndHelpers");
const dev = process.env.REACT_APP_DEBUG;
const typeName = 'SpreadingEvent';
class SpreadingEvent extends datamodel_core_1.Area {
    constructor(ob) {
        var _a, _b, _c;
        super({ ...ob, type: typeName });
        this.path = ob.path;
        this.points = ob.irrigatedArea;
        this.irrigatedArea = ob.irrigatedArea;
        this.output = ob.output;
        this.duration = ob.duration;
        this.startTime = ob.startTime;
        this.endTime = ob.endTime;
        this.spreaderName = ob.spreaderName;
        this.spreaderID = ob.spreaderID;
        this.spreaderPK = ob.spreaderPK;
        this.distance = ob.distance;
        this.area = ob.area;
        this.overlappedAreas = ob.overlappedAreas;
        this.mappedRun = (_a = ob.mappedRun) !== null && _a !== void 0 ? _a : null;
        // this.filteredPath = ob.filteredPath;
        // this.mappedPath = ob.mappedPath;
        this.runDifference = ob.runDifference;
        this.pressure = ob.pressure;
        this.applicationDepth = ob.applicationDepth;
        this.applicationDepthMM = ob.applicationDepthMM ? ob.applicationDepthMM : ob.applicationDepth ? ob.applicationDepth * 10 : 0;
        this.pumpState = ob.pumpState || [];
        this.pressureList = ob.pressureList;
        this.moistureReadingsList = ob.moistureReadingsList;
        this.soilRisk = ob.soilRisk || 'Unknown';
        this.type = 'SpreadingEvent';
        this.isManuallyGenerated = (_b = ob.isManuallyGenerated) !== null && _b !== void 0 ? _b : false;
        this.hide = (_c = ob.hide) !== null && _c !== void 0 ? _c : false;
    }
    getCoverageAndArea(spreaderList, effluentRuns) {
        var _a, _b, _c;
        let useLogic = this._areaPointsMapping;
        if (dev || useLogic === undefined) {
            let matchedSpreader = spreaderList.find((spreader) => spreader.id === this.spreaderID);
            if (matchedSpreader === undefined) {
                return this.irrigatedArea;
            }
            let shallowCopy;
            const data = { ...matchedSpreader, path: this.path };
            switch (matchedSpreader.type) {
                case 'PivotEffluentSpreader':
                    shallowCopy = new PivotEffluentSpreader_1.PivotEffluentSpreader(data);
                    break;
                case 'LateralEffluentSpreader':
                    shallowCopy = new LateralEffluentSpreader_1.LateralEffluentSpreader(data);
                    break;
                case 'TravellingEffluentSpreader':
                    shallowCopy = new TravellingEffluentSpreader_1.TravellingEffluentSpreader(data);
                    break;
                case 'SpreadingGun':
                    shallowCopy = new SpreadingGun_1.SpreadingGun(data);
                    break;
                default:
                    shallowCopy = new EffluentTracker_1.EffluentTracker(data);
            }
            let run = undefined;
            if (effluentRuns) {
                const expectedPathObj = shallowCopy.getExpectedRun(effluentRuns);
                if (expectedPathObj) {
                    run = expectedPathObj.run;
                }
            }
            let runRes = shallowCopy.getSpreadOfAllRuns(run);
            this._areaPointsMapping = runRes;
            useLogic = runRes;
        }
        return ((_a = useLogic === null || useLogic === void 0 ? void 0 : useLogic.mapped) === null || _a === void 0 ? void 0 : _a.positions) || ((_b = useLogic === null || useLogic === void 0 ? void 0 : useLogic.filtered) === null || _b === void 0 ? void 0 : _b.positions) || ((_c = useLogic === null || useLogic === void 0 ? void 0 : useLogic.raw) === null || _c === void 0 ? void 0 : _c.positions) || this.irrigatedArea;
    }
    recalculateWithoutContext(areas, runs) {
        return this;
    }
    /**
     * Update the current spreading event with new details
     * @param event
     */
    updateCurrentEventWithNewEvent(tracker, event) {
        this.irrigatedArea = event.irrigatedArea;
        this.output = event.output;
        this.area = event.area;
        this.overlappedAreas = event.overlappedAreas;
        this.mappedRun = event.mappedRun;
        this.runDifference = event.runDifference;
        this.points = event.points;
        // this.pressure = event.pressure;
        this.applicationDepthMM = event.applicationDepthMM;
        this.startTime = event.startTime;
        this.endTime = event.endTime;
        this.duration = event.duration;
    }
    recalculateWithPK(tracker, areas, runs, lastTime) {
        let spreader;
        let temp = { ...tracker, path: this.path, name: tracker.name };
        switch (tracker.type) {
            case 'LateralEffluentSpreader':
                spreader = new LateralEffluentSpreader_1.LateralEffluentSpreader(temp);
                break;
            case 'TravellingEffluentSpreader':
                spreader = new TravellingEffluentSpreader_1.TravellingEffluentSpreader(temp);
                break;
            case 'PivotEffluentSpreader':
                // need to know if pivot on lateral or effluent
                spreader = new PivotEffluentSpreader_1.PivotEffluentSpreader(temp);
            case 'SpreadingGun':
                spreader = new SpreadingGun_1.SpreadingGun(temp);
                let bestMatched = spreader.getBestMatchedRun(runs);
                if (bestMatched) {
                    switch (bestMatched.run.pathType) {
                        case DefinitionAndHelpers_1.EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
                            spreader = new LateralEffluentSpreader_1.LateralEffluentSpreader({ ...spreader });
                            break;
                        case DefinitionAndHelpers_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
                            spreader = new PivotEffluentSpreader_1.PivotEffluentSpreader({ ...spreader });
                            break;
                    }
                }
                break;
            default:
                spreader = new EffluentTracker_1.EffluentTracker(temp);
        }
        spreader.updateMappedRun(runs, lastTime);
        const { Spreading } = spreader.createSpreadingEventAndDeadZone(areas, runs);
        this.updateCurrentEventWithNewEvent(spreader, Spreading);
        return this;
        // return { ...this, ...Spreading, spreaderPK: spreader.pk };
    }
    recalculateSpreadingEvent(effluentSpreaders = [], areas = [], runs = []) {
        // check if DOES NOT have pk. calculate the expected PK of the ID
        let lastTime = Date.now();
        if (this.path !== undefined) {
            lastTime = this.path[this.path.length - 1].timestamp;
        }
        else {
            console.log('SE: No path found!', this.pk);
        }
        // if (this.spreaderPK === undefined || this.spreaderPK === '') {
        let found = effluentSpreaders.find((spread) => spread.id === this.spreaderID);
        // let found = effluentSpreaders.find((spread) => spread.name === this.spreaderName);
        if (found !== undefined) {
            this.spreaderPK = found.pk;
            // this.spreaderID = found.id;
        }
        if (this.spreaderPK !== undefined) {
            let found = effluentSpreaders.find((spread) => spread.pk === this.spreaderPK);
            if (found !== undefined) {
                return this.recalculateWithPK(found, areas, runs, lastTime);
            }
        }
        // return this;
        return this.recalculateWithoutContext(areas, runs);
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'identification',
                validation: {
                    regex: /^[\p{L}0-9\s']+$/u,
                    pass: false,
                    invalidMessage: 'Name cannot contain invalid characters',
                },
            },
            output: {
                type: 'Number',
                editable: false,
                label: 'Output (L)',
                name: 'output',
                description: 'Flow output of run',
            },
            duration: {
                type: 'Number',
                editable: false,
                label: 'Duration (min)',
                name: 'duration',
                description: 'Effluent Spreading Duration',
            },
            description: {
                type: 'String',
                editable: true,
                label: 'Description',
                description: 'description',
            },
            distance: {
                type: 'Number',
                editable: false,
                label: 'Distance (m)',
                name: 'distance',
                description: 'Distance the effluent spreader travelled',
            },
            concentration: {
                type: 'Number',
                editable: false,
                label: 'Concentration (L/m^2)',
                name: 'concentration',
                description: 'Concentrate of effluent for this run',
            },
            pressure: {
                type: 'Number',
                editable: false,
                label: 'Pressure (KPa)',
                name: 'Pressure',
                description: 'Pressure (KPa) of the fluid ',
            },
        };
    }
}
exports.SpreadingEvent = SpreadingEvent;
